"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StableCoin__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_decimals",
                type: "uint8",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "allowance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientAllowance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address",
            },
        ],
        name: "ERC20InvalidApprover",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "ERC20InvalidReceiver",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSpender",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DECIMALS",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class StableCoin__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_decimals, overrides) {
        return super.getDeployTransaction(_decimals, overrides || {});
    }
    deploy(_decimals, overrides) {
        return super.deploy(_decimals, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.StableCoin__factory = StableCoin__factory;
